module.exports = __webpack_public_path__ + "assets/confetti-95f924.svg";